<template>
  <select class="form-control">
    <option disabled selected hidden v-if="isOptional"></option>
    <option disabled selected hidden v-else>Select one</option>
    <option v-for="item in dropdowns" :value="item">{{item}}</option>
  </select>
</template>

<script>
  import dropdowns from 'src/common/resources/standardOptions.js'

  export default {
    name: "customSelect",
    data() {
      return {
        dropdowns: dropdowns.dropdowns[this.options],
      }
    },
    props: {
      options: String,
      isOptional: Boolean,
    }
  }
</script>

<style scoped>

</style>
